import axios from 'axios';
import { ensureProtocol } from '../config/backend';
import { refreshAccessToken as refreshAnalista } from '../App/tokenManager';

function ehRotaPublicaSolicitante(url, method) {
    if (!url || typeof url !== 'string') return false;
    const u = url.toLowerCase();
    const m = (method || '').toLowerCase();
    return (
        u.indexOf('conusuarioentrada') !== -1 ||
        (u.indexOf('/api/token') !== -1 && m === 'post') ||
        (u.indexOf('/token') !== -1 && u.indexOf('/api/') === -1 && m === 'post') ||
        (u.indexOf('/api/refresh') !== -1 && m === 'post')
    );
}

function ehRotaAuth(url, method) {
    if (ehRotaPublicaSolicitante(url, method)) return true;
    if (!url || typeof url !== 'string') return false;
    return url.toLowerCase().indexOf('/token') !== -1;
}

axios.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('token');
        const url = (config.url || '').toString();
        const method = (config.method || 'get').toLowerCase();
        const ipBackend = localStorage.getItem('ipBackend');
        const tipoSoft = localStorage.getItem('tipoSoft');

        const ehBackendSolicitante = ipBackend && url.indexOf(ipBackend) !== -1;
        const exigeTokenSolicitante = tipoSoft === 'SOLICITANTE' && ehBackendSolicitante && !ehRotaPublicaSolicitante(url, method);

        if (exigeTokenSolicitante && (!token || token.trim() === '')) {
            window.location.href = '/Solicitante';
            return Promise.reject(new Error('Token obrigatório. Faça login novamente.'));
        }

        if (token && !config.headers.Authorization) {
            config.headers.Authorization = token.startsWith('Bearer ') ? token : 'Bearer ' + token;
        }
        return config;
    },
    (err) => Promise.reject(err)
);

axios.interceptors.response.use(
    (response) => response,
    async (err) => {
        const status = err?.response?.status;
        const config = err?.config;
        const url = (config?.url || '').toString();
        const method = config?.method || 'get';

        if (status === 401 && !config?._retryRenovacao) {
            if (ehRotaAuth(url, method)) {
                return Promise.reject(err);
            }

            const refreshToken = localStorage.getItem('refreshToken');
            const ipBackend = localStorage.getItem('ipBackend');
            const ipBackend2 = localStorage.getItem('ipBackend2');
            const tipoSoft = localStorage.getItem('tipoSoft');

            if (tipoSoft === 'SOLICITANTE' && refreshToken && ipBackend && url.indexOf(ipBackend) !== -1) {
                try {
                    const baseUrl = ensureProtocol(ipBackend);
                    const res = await axios.post(baseUrl + '/api/refresh', { refreshToken }, { validateStatus: (s) => s < 500 });
                    if (res.status === 200 && res.data?.token) {
                        localStorage.setItem('token', res.data.token.startsWith('Bearer ') ? res.data.token : 'Bearer ' + res.data.token);
                        if (res.data.refreshToken) localStorage.setItem('refreshToken', res.data.refreshToken);
                        config._retryRenovacao = true;
                        config.headers = config.headers || {};
                        config.headers.Authorization = res.data.token.startsWith('Bearer ') ? res.data.token : 'Bearer ' + res.data.token;
                        return axios(config);
                    }
                } catch (_) {  }
            }

            const ehBackendAnalista = ipBackend2 && url.indexOf(ipBackend2) !== -1;
            if (tipoSoft !== 'SOLICITANTE' && (ehBackendAnalista || !ipBackend2)) {
                try {
                    const novo = await refreshAnalista();
                    if (novo) {
                        config._retryRenovacao = true;
                        config.headers = config.headers || {};
                        config.headers.Authorization = novo.startsWith('Bearer ') ? novo : 'Bearer ' + novo;
                        return axios(config);
                    }
                } catch (_) {  }
            }

            localStorage.setItem('token', '');
            localStorage.setItem('refreshToken', '');
            if (tipoSoft === 'SOLICITANTE') {
                window.location.href = '/Solicitante';
            } else {
                window.location.href = '/';
            }
        }
        return Promise.reject(err);
    }
);
